import React from 'react'
import { view } from 'react-easy-state'
import DocumentRender from 'components/common/DocumentRender'

class PaperView extends React.Component {

  render() {

    const { paper } = this.props

    const document = {
      url: paper.url,
      type: paper.paper_type
    }

    return <DocumentRender document={document} title={paper.name}/>

  }
}

export default view(PaperView)
